import Burger from '@/components/burger/burger-component';
import Profile from '@/components/profile/profile-component';
import PropTypes from 'prop-types';
import logo from '@/assets/svg/ettx-logo-dark.svg';
import Currency from '../currency/currency-component';
import Styled from './header-style';

// TODO: Add portal for buttons

/**
 * Header component.
 * @param {object} props The props.
 * @param {boolean} props.burgerMenu The burger menu.
 * @param {func} props.burgerMenuToggle The burger menu toggle.
 * @param {string}props.shopLogo - company logo
 * @param {boolean} props.currency - should show currency
 * @returns {JSX.Element} The rendered Header component.
 */
const Header = ({ shopLogo, burgerMenu, burgerMenuToggle, currency }) => (
  <Styled.TopNavigation>
    <Burger open={burgerMenu} setOpen={burgerMenuToggle} />
    <Styled.Logo src={shopLogo ?? logo} />
    <Styled.Right>
      {currency && <Currency />}
      <Profile />
    </Styled.Right>
  </Styled.TopNavigation>
);

Header.defaultProps = {
  shopLogo: undefined,
  currency: true,
};

Header.propTypes = {
  burgerMenu: PropTypes.bool.isRequired,
  burgerMenuToggle: PropTypes.func.isRequired,
  shopLogo: PropTypes.string,
  currency: PropTypes.bool,
};
export default Header;
